import axios from "./axios";
import { normalizeError } from "../operationFeedback/normalizeError";

const root = "/company/accounting";
async function request(method, path, data, params, signal) {
  try {
    const response = await axios({ method, url: `${root}/${path}`, data, params, signal });
    if (!response.data || response.data.data == null) {
      throw new Error("Invalid economy response");
    }
    return response.data;
  } catch (error) {
    throw normalizeError(error);
  }
}
export const economyApi = {
  overviewPdf: (params, signal) => axios.get(`${root}/planning/overview/pdf`, {
    params,
    signal,
    responseType: "blob",
    headers: { Accept: "application/pdf" },
  }),
  liquidity: (data, signal) => request("post", "planning/liquidity", data, undefined, signal),
  vehiclePostings: (params, signal) => request("get", "planning/vehicle_postings", undefined, params, signal),
  linkPosting: (data) => request("post", "planning/vehicle_postings", data),
  unlinkPosting: (id, lock_version) => request("delete", `planning/vehicle_postings/${id}`, { lock_version }),
  sources: (params, signal) => request("get", "planning/sources", undefined, params, signal),
  estimates: (params, signal) => request("get", "planning/estimates", undefined, params, signal),
  settings: (key, signal) => request("get", `planning/settings/${encodeURIComponent(key)}`, undefined, undefined, signal),
  saveSettings: (key, data) => request("put", `planning/settings/${encodeURIComponent(key)}`, data),
  budgets: (params, signal) => request("get", "budgets", undefined, params, signal),
  budget: (id, signal) => request("get", `budgets/${id}`, undefined, undefined, signal),
  history: (id, page, signal) => request("get", `budgets/${id}/history`, undefined, { page }, signal),
  calculate: (inputs, signal) => request("post", "budgets/calculate", { inputs }, undefined, signal),
  saveBudget: (data) => request(data.id ? "patch" : "post", data.id ? `budgets/${data.id}` : "budgets", data),
  transition: (id, event, lock_version) => request("post", `budgets/${id}/transition`, { event, lock_version }),
};
